import React, { useCallback, useContext } from 'react';
import SidePanelContext from '../../../contexts/SidePanelContext';

import EditEmailTemplatesPage
    from '../../email/EditEmailTemplatesPage/EditEmailTemplatesPage';

export const useMessageEditor = () => {
    const { showSidePanel, hideSidePanel } = useContext(SidePanelContext);
    const showMessageEditor = useCallback(
        (body) => {
            const id = showSidePanel({
                position: 'right',
                hasCloseButton: false,
                width: '37.5%',
                minWidth: '540px',
                body: <EditEmailTemplatesPage
                    onClose={() => hideSidePanel(id)}
                />,
            });
        },
        [showSidePanel],
    );

    return showMessageEditor;
};
